import { HStack, Text } from "@chakra-ui/react";

interface LegalLiProps {
  children: React.ReactNode;
}

export default function LegalLi({ children }: LegalLiProps) {
  return (
    <HStack align="flex-start" gap={2} mb={2}>
      <Text fontFamily="body" fontSize="14px" color="accent.secondary" mt="2px" flexShrink={0}>–</Text>
      <Text fontFamily="body" fontWeight="300" fontSize="14px" lineHeight="1.8" color="text.primary" opacity={0.8}>
        {children}
      </Text>
    </HStack>
  );
}
